import type { IExtractRouteParamMap } from "../../../types";
import {
  academicGroupBreadcrumbs,
  academicGroupRoutesObj,
} from "../academicGroup/path";
import {
  facultyMembersRouteTranslation,
  facultyMembersRoutesObj,
} from "../../usersManagement/facultyMembers/path";

import {
  concatBreadcrumbs,
  createBreadcrumbObject,
  createPaths,
  rebase,
} from "@/routes/utils";

const baseRoute = academicGroupRoutesObj.view;
const baseBreadcrumb = academicGroupBreadcrumbs.view;

// * Route configuration object for academicGroupMembers-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const academicGroupMembersRoutesObj = {
  list: `${baseRoute}${facultyMembersRoutesObj.list}`,
  create: `${baseRoute}${facultyMembersRoutesObj.create}`,
  view: `${baseRoute}${facultyMembersRoutesObj.view}`,
  edit: `${baseRoute}${facultyMembersRoutesObj.edit}`,
} as const;

// * Extracts the route parameters for the academic group members route configuration.
export type IAcademicGroupMembersRouteParams = IExtractRouteParamMap<
  typeof academicGroupMembersRoutesObj
>;

// * Path functions for the academicGroupMembers routes.
export const academicGroupMembersPath = createPaths<
  typeof academicGroupMembersRoutesObj,
  IAcademicGroupMembersRouteParams
>(academicGroupMembersRoutesObj);

// * Breadcrumbs {translation and route} for the academicGroupMembers routes
const newAcademicGroupMembersBreadcrumbs = createBreadcrumbObject<
  typeof academicGroupMembersRoutesObj
>(academicGroupMembersRoutesObj, facultyMembersRouteTranslation);

rebase(newAcademicGroupMembersBreadcrumbs, "list");

export const academicGroupMembersBreadcrumbs = concatBreadcrumbs<
  typeof academicGroupMembersRoutesObj
>(baseBreadcrumb, newAcademicGroupMembersBreadcrumbs);
